module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "crt"
  }, [_c('b', [_c('i', [_vm._v("These Are My People: The Merle Kilgore Story")])])]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_vm._v("© 2016 Mark Rickert. All rights reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "crt2"
  }, [_vm._v("No part of this book may be reproduced in any form or by any means, electronic, mechanical, digital, photocopying, or recording, except for the inclusion in a review, without permission in writing from the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "crt2"
  }, [_vm._v("Published in the United States by WriteLife Publishing")]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_vm._v("(An imprint of Boutique of Quality Books Publishing Company)")]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_c('a', {
    attrs: {
      "href": "http://www.writelife.com",
      "id": "A38",
      "target": "_blank"
    }
  }, [_vm._v("www.writelife.com")])]), _vm._v(" "), _c('p', {
    staticClass: "crt2"
  }, [_vm._v("978-1-60808-172-1 (p)")]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_vm._v("978-1-60808-173-8 (e)")]), _vm._v(" "), _c('p', {
    staticClass: "crt2"
  }, [_vm._v("Library of Congress Control Number: 2016947894")]), _vm._v(" "), _c('p', {
    staticClass: "crt2"
  }, [_vm._v("Book design by Robin Krauss, "), _c('a', {
    attrs: {
      "href": "http://bookformatters.com",
      "id": "A6I",
      "target": "_blank"
    }
  }, [_vm._v("bookformatters.com")])]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_vm._v("Cover design by Ellis Dixon, "), _c('a', {
    attrs: {
      "href": "http://ellisdixon.com",
      "id": "ADC",
      "target": "_blank"
    }
  }, [_vm._v("ellisdixon.com")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f2a70f58","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/copyrightpage.vue
// module id = 60
// module chunks = 0